<template>
  <div class="blog-main-content">
    <BlogList class="right"/>
    <h1>The Pit (Terror Zone) Efficient Run Guide</h1>
    <p>When The Pit becomes a Terror Zone, monster levels significantly increase, making it an excellent location for efficient experience farming and high-tier item drops. The Pit is located in Act 1’s Tamoe Highland and is a high-density area with numerous elite monsters. It can drop all high-end gear, making it one of the best spots for both leveling and Magic Find (MF).</p>

    <h2>The Pit Location & Route Planning</h2>
    <h3>How to Find The Pit</h3>
    <ol>
        <li>Start from the Outer Cloister waypoint, exit through the gate into Tamoe Highland.</li>
        <li>Follow the paths to locate The Pit entrance. There may be forks in the road, one of which leads to Black Marsh.</li>
        <li>If you reach Black Marsh, turn back and take the other path to find The Pit entrance.</li>
    </ol>
    <p>The Pit consists of two levels, with the second level having more elite monsters. Fully clearing both levels maximizes experience and loot.</p>

    <div>
      <img class="m-1 w-100" alt="Pit run" src="@/assets/runs/pit-run.png">
    </div>

    <h2>Monster Characteristics & Farming Advantages</h2>
    <ul>
        <li><strong>Low monster resistances</strong>, making it suitable for multiple builds – Includes Fallen, Skeleton Warriors, Archers, mostly Undead and Demon types with few high-resist enemies.</li>
        <li><strong>High monster density</strong>, providing excellent experience – Monsters are tightly packed, making it ideal for AOE-heavy builds.</li>
        <li><strong>Many elite monsters</strong> – It can drop every top-tier item, such as Crown of Age, Griffon’s Eye, and more.</li>
        <li><strong>Suitable for multiple builds</strong> – Lightning Sorceress, Nova Sorceress, Poison Necromancer, Mosaic Assassin, Physical Bowazon, Summon Necromancer all perform well here.</li>
    </ul>

    <div id="slot-content_mpu" class="content-ad-mpu"/>

    <h2>Recommended Builds for Farming The Pit</h2>
    <ul>
        <li><strong>Lightning Sorceress – The AOE Clearer</strong>
            <ul>
                <li>Strengths: Uses Lightning + Chain Lightning, with Infinity-equipped mercenary to break monster resistances, providing extremely fast clears.</li>
                <li><strong>Gear Recommendation:</strong> Prioritize high Faster Cast Rate (FCR) gear like Skin of the Vipermagi + Spirit Shield for better survivability and damage.</li>
            </ul>
        </li>
        <li><strong>Nova Sorceress – Excellent for High-Density Farming</strong>
            <ul>
                <li>Strengths: Nova deals massive AOE damage at close range, making it perfect for The Pit’s narrow corridors.</li>
                <li><strong>Gear Recommendation:</strong> Skin of the Vipermagi + Spirit + Infinity Mercenary for increased lightning damage.</li>
            </ul>
        </li>
        <li><strong>Poison Necromancer – High DOT & Corpse Explosion Clear</strong>
            <ul>
                <li>Strengths: Poison Nova deals heavy damage over time, while Corpse Explosion rapidly clears crowds.</li>
                <li><strong>Gear Recommendation:</strong> Death’s Web + Trang-Oul’s Claws + Enigma for enhanced poison damage and mobility.</li>
            </ul>
        </li>
        <li><strong>Mosaic Assassin – High-Speed Charge-Up Playstyle</strong>
            <ul>
                <li>Strengths: Dual Mosaic runewords allow for infinite Phoenix Strike charges, dealing massive elemental damage.</li>
                <li><strong>Gear Recommendation:</strong> Dual Mosaic + Enigma for rapid clear speeds.</li>
            </ul>
        </li>
        <li><strong>Physical Bowazon – High Single-Target Damage for Elites</strong>
            <ul>
                <li>Strengths: Uses Multiple Shot + Guided Arrow, excelling at killing high-health monsters and elites.</li>
                <li><strong>Gear Recommendation:</strong> Faith Bow for high physical damage.</li>
            </ul>
        </li>
        <li><strong>Summon Necromancer – Safe & Effective for Group Play</strong>
            <ul>
                <li>Strengths: Skeleton Warriors + Corpse Explosion provide strong crowd control and high AOE damage.</li>
                <li><strong>Gear Recommendation:</strong> Enigma + Beast + Arm of King Leoric for stronger summons.</li>
            </ul>
        </li>
    </ul>

    <h2>Efficient Farming Strategies</h2>

    <h3>Solo Speed Farming Route</h3>
    <ol>
        <li>Use the Outer Cloister waypoint, teleport to Tamoe Highland, and locate The Pit entrance.</li>
        <li>Fully clear The Pit Level 1, focusing on elite monsters.</li>
        <li>Proceed to The Pit Level 2 and clear everything, prioritizing elites.</li>
        <li>After clearing, you can Reset the game and repeat the run.</li>
    </ol>

    <h3>Group Farming Strategy</h3>
    <ol>
        <li>A Sorceress should teleport ahead, locating The Pit and guiding the party.</li>
        <li>AOE builds (Lightning Sorc, Nova Sorc, Poison Necro, Mosaic Assassin) should clear monster packs, while Bowazons focus on high-health elites.</li>
        <li>Summon Necromancers provide extra minions for tanking and use Corpse Explosion for quick clearing.</li>
        <li>An Infinity Mercenary is highly recommended to reduce monster resistances, improving Lightning and Poison efficiency.</li>
    </ol>
  </div>
</template>

<script>
import BlogList from '../BlogList.vue'

export default {
  name: 'Pit',

  components: {
    BlogList,
  },
}
</script>